import React, { useState, useContext, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTheme, useMediaQuery } from '@mui/material';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import { AuthContext } from 'src/context/AuthContext';
import SubmitDwrModal from 'src/components/StaffsideComponent/StaffDWR/StaffDwrCreate/submit_dwr_modal';
import dayjs from 'dayjs';

import Modal from '@mui/material/Modal';
import {
  IconButton,
  Backdrop,
  CircularProgress,
  Dialog,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  TableHead,

} from '@mui/material';

import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import ViewListIcon from '@mui/icons-material/ViewList';
import CommentIcon from '@mui/icons-material/Comment';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import BookOnlineIcon from '@mui/icons-material/BookOnline';

import CommentsModal from 'src/components/SharedComponent/Scheduling/comment_modal';
import { getScheduleColor } from 'src/utils/scheduleColorUtils';
import ColorLegend from 'src/components/SharedComponent/Scheduling/ColorLegend';
import ViewLeaveModal from 'src/components/SharedComponent/EmployeeLeaves/ViewLeaveModal';
import ViewPrebookingModal from 'src/components/SharedComponent/Prebooking/ViewPrebookingModal';

const { PRIVATE_ROUTE } = API_ROUTES;

const styles = {
  calendar: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    width: '100%',
    margin: 'auto',
    gap: '3px',
    fontFamily: 'Arial, sans-serif',
  },

  header: {
    fontWeight: 'bold',
    textAlign: 'center',
    padding: '8px 4px',
    backgroundColor: '#eee',
    fontSize: 'clamp(10px, 1.5vw, 15px)',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },

  cell: {
    minHeight: '100px',
    border: '1px solid #ccc',
    textAlign: 'center',
    backgroundColor: '#fafafa',
    cursor: 'pointer',
    position: 'relative',
    padding: '0 0 1em',
    overflow: 'hidden',
    minWidth: 0,
  },
  dateCircle: {
    position: 'absolute',
    top: '2px',
    left: '2px',
    borderRadius: '50%',
    fontSize: 'clamp(9px, 1.2vw, 12px)',
  },
  moreItem: {
    fontSize: 'clamp(9px, 1.2vw, 12px)',
    fontWeight: 'bold',
  },
  moreItemCount: {
    fontSize: 'clamp(9px, 1.2vw, 12px)',
    fontWeight: 'normal',
  },
  empty: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'default',
  },
  container: {
    maxWidth: '450px',
    margin: '30px auto',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
  },
  controls: {
    marginBottom: '15px',
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    flexWrap: 'wrap',
  },
  select: {
    padding: '6px 10px',
    fontSize: '14px',
  },
  taskLeftColumn: {
    color: '#000',
    fontWeight: 'bold',
    backgroundColor: '#e2f0f5',
  },
  taskRightColumn: {
    color: '#000',
    fontWeight: 'bold',
    backgroundColor: '#f1f1f1',
  },
  tableRow: {
    padding: '2px',
    border: 'solid 2px #fff',
  },
  button: {
    padding: '6px 14px',
    fontSize: '14px',
    cursor: 'pointer',
    backgroundColor: '#3DADB5',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
  },
  event: {
    background: '#E0F6F8',
    borderRadius: '3px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    fontSize: 'clamp(8px, 1vw, 12px)',
    borderBottom: '2px solid #fff',
    display: 'block',
  },
};
const style = {
  width: '100%',
  height: 'calc(100vh - 92px)',
  p: { xs: 1, sm: 2, md: 3 },
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

const formatDate = (y, m, d) => `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

const getAssignedEmployeeId = (member) => {
  const employee =
    member?.employee_data ||
    member?.employee ||
    member?.employee_id ||
    member;

  if (employee && typeof employee === 'object') {
    return String(employee._id || employee.id || '');
  }

  return String(employee || '');
};

const isCurrentEmployeeInGroup = (schedules, currentUserId) => {
  if (!currentUserId || !Array.isArray(schedules)) {
    return false;
  }

  const loggedInId = String(currentUserId);

  return schedules.some((schedule) =>
    (schedule?.assigned_members || []).some((member) =>
      getAssignedEmployeeId(member) === loggedInId
    )
  );
};


const getGroupMembers = (schedules) => {
  const members = (schedules || []).flatMap(
    (schedule) => schedule?.assigned_members || []
  );

  const uniqueMembers = new Map();

  members.forEach((member) => {
    const employee =
      member?.employee_data ||
      member?.employee ||
      member?.employee_id ||
      member;

    const employeeId =
      typeof employee === 'object'
        ? String(employee?._id || employee?.id || '')
        : String(employee || '');

    // Get the name from the employee object or assignment record.
    const firstName =
      employee?.first_name || member?.first_name || '';
    const lastName =
      employee?.last_name || member?.last_name || '';

    const name = `${firstName} ${lastName}`.trim();
    const key = employeeId || name.toLowerCase();

    if (key && name && !uniqueMembers.has(key)) {
      uniqueMembers.set(key, {
        id: employeeId,
        name,
      });
    }
  });

  return [...uniqueMembers.values()];
};

export default function CalenderView({ openStatus, setCalendar }) {
  const theme = useTheme();
  const isMobilePortrait = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobileLandscape = useMediaQuery('(max-height: 500px) and (orientation: landscape)');
  const isMobile = isMobilePortrait || isMobileLandscape;
  const navigate = useNavigate();

  const handleClose = () => setOpen(false);

  const today = new Date();

  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [loading, setLoading] = useState(true);

  const [calanderData, setcalanderData] = useState(null);

  const [expandedDate, setExpandedDate] = useState(null);
  const [selectedDayPopup, setSelectedDayPopup] = useState(null); // { dateKey, dayEvents }
  const [openCommentModal, setCommentModal] = useState(false);
  const [selectedCommentSchedule, setSelectedCommentSchedule] = useState(null);
  const [holidayMap, setHolidayMap] = useState({}); // { 'YYYY-MM-DD': description }
  const [leaveDates, setLeaveDates] = useState([]);
  const [leaveRecords, setLeaveRecords] = useState([]);
  const [viewLeaveModal, setViewLeaveModal] = useState({ open: false, date: '', records: [] });
  const [prebookingDates, setPrebookingDates] = useState([]);
  const [prebookingRecords, setPrebookingRecords] = useState([]);
  const [viewPrebookingModal, setViewPrebookingModal] = useState({ open: false, date: '', records: [] });
  const [tooltipOpenDate, setTooltipOpenDate] = useState(null);
  const [commentCounts, setCommentCounts] = useState({});
  const [dwrRefreshKey, setDwrRefreshKey] = useState(0);
  const fetchedCommentIds = React.useRef(new Set());

  const { state } = useContext(AuthContext);
  const { authAxios } = useContext(FetchContext);

  const fetchCommentCount = useCallback(
    async (scheduleId) => {
      if (fetchedCommentIds.current.has(scheduleId)) return;
      fetchedCommentIds.current.add(scheduleId);
      try {
        const res = await authAxios.get(`${PRIVATE_ROUTE?.FETCH_ALL_COMMENTS}?schedule_id=${scheduleId}`);
        const count = (res?.data?.data || []).length;
        setCommentCounts((prev) => ({ ...prev, [scheduleId]: count }));
      } catch {
        // silently ignore — button shows without highlight
      }
    },
    [authAxios]
  );

  const getData = React.useCallback(
    async (yr, mo) => {
      fetchedCommentIds.current.clear();
      setCommentCounts({});

      try {
        /*
         * Keep the existing UI/month convention:
         *
         * January  = 0
         * September = 8
         * October   = 9
         * November  = 10
         *
         * The backend expects this same zero-based month.
         */

        const previousMonth = mo === 0 ? 11 : mo - 1;
        const previousYear = mo === 0 ? yr - 1 : yr;

        /*
         * Fetch both:
         *
         * 1. Requested month
         * 2. Previous month
         *
         * The previous-month request is needed because the backend
         * creates its date range using the server's local timezone.
         *
         * A record stored as:
         *   2026-10-01T00:00:00.000Z
         *
         * can therefore fall just before the backend's local
         * October start boundary.
         *
         * We recover those first-day records from the previous-month
         * response and then filter everything back to the requested
         * calendar month below.
         */

        const [currentResponse, previousResponse] = await Promise.all([
          authAxios.get(
            `${PRIVATE_ROUTE?.GET_SCHEDULEALL}?year=${yr}&month=${mo}`
          ),
          authAxios.get(
            `${PRIVATE_ROUTE?.GET_SCHEDULEALL}?year=${previousYear}&month=${previousMonth}`
          ),
        ]);

        const currentSchedules =
          currentResponse?.data?.data || [];

        const previousSchedules =
          previousResponse?.data?.data || [];

        /*
         * Merge both API responses.
         *
         * Use _id to avoid duplicates.
         */
        const scheduleMap = new Map();

        [...previousSchedules, ...currentSchedules].forEach((schedule) => {
          if (!schedule?._id) return;

          scheduleMap.set(String(schedule._id), schedule);
        });

        /*
         * Keep ONLY schedules that belong to the month/year
         * currently displayed by the calendar.
         *
         * IMPORTANT:
         * Do not convert the date using new Date().
         *
         * The application stores/uses planned_date as the calendar
         * date in YYYY-MM-DD form.
         */
        const targetPrefix = `${yr}-${String(mo + 1).padStart(2, '0')}`;

        const schedulesForMonth = Array.from(scheduleMap.values()).filter(
          (schedule) => {
            if (!schedule?.planned_date) return false;

            const formattedDate = String(schedule.planned_date).split('T')[0];

            return formattedDate.startsWith(targetPrefix);
          }
        );

        let schedule_data = {};

        schedulesForMonth.forEach((schedule) => {
          /*
           * Preserve the old behavior.
           */
          if (!schedule.group_number || schedule.group_number === 0) {
            return;
          }

          /*
           * Preserve the old date handling exactly.
           *
           * Example:
           * 2026-10-01T00:00:00.000Z
           * becomes
           * 2026-10-01
           */
          const formatted_date = schedule.planned_date.split('T')[0];

          if (!schedule_data[formatted_date]) {
            schedule_data[formatted_date] = {};
          }

          if (schedule_data[formatted_date][`${schedule.group_number}`]) {
            schedule_data[formatted_date][`${schedule.group_number}`].push(
              schedule
            );
          } else {
            schedule_data[formatted_date][`${schedule.group_number}`] = [
              schedule,
            ];
          }
        });

        setcalanderData(schedule_data);
      } catch (error) {
        console.error('Failed to fetch calendar schedules', error);
        setcalanderData({});
      }
    },
    [authAxios]
  );

  useEffect(() => {
    getData(year, month);
  }, [year, month, getData]);

  const getHolidays = async (yr) => {
    const { data } = await authAxios.get(`${PRIVATE_ROUTE?.GET_HOLIDAYS}`);
    const map = {};
    (data?.data ?? []).forEach((h) => {
      const dateKey = h.date.split('T')[0];
      if (parseInt(dateKey.substring(0, 4), 10) === yr) {
        map[dateKey] = h.description;
      }
    });
    setHolidayMap(map);
  };

  useEffect(() => {
    getHolidays(year);
  }, [year]);

  const currentUser = state?.user;
  const isAdminOrManager = currentUser?.role === 'admin' || currentUser?.role === 'manager';

  // ============================================================
  // DWR STATE
  // ============================================================

  const [
    availableDwrModalOpen,
    setAvailableDwrModalOpen,
  ] = useState(false);

  const [
    availableDwrLoading,
    setAvailableDwrLoading,
  ] = useState(false);

  const [
    availableDwrWork,
    setAvailableDwrWork,
  ] = useState([]);

  const [
    selectedDwrWork,
    setSelectedDwrWork,
  ] = useState(null);

  const [
    submitDwrModalOpen,
    setSubmitDwrModalOpen,
  ] = useState(false);

  const fetchLeaves = useCallback(async () => {
    try {
      const { data } = await authAxios.get(`${PRIVATE_ROUTE.GET_EMPLOYEE_LEAVES}?year=${year}&month=${month + 1}`);
      const records = data.data || [];
      setLeaveRecords(records);
      // Expand range leaves into individual date strings for the current month
      const mo = month + 1;
      const lastDay = new Date(year, mo, 0).getDate();
      const monthStart = `${year}-${String(mo).padStart(2, '0')}-01`;
      const monthEnd = `${year}-${String(mo).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
      const allDates = [];
      records.forEach((l) => {
        const from = l.date_from?.substring(0, 10);
        if (!from) return;
        const to = l.date_to?.substring(0, 10);
        if (!to || from === to) { allDates.push(from); return; }
        const clampedStart = from > monthStart ? from : monthStart;
        const clampedEnd = to < monthEnd ? to : monthEnd;
        let cur = new Date(`${clampedStart}T00:00:00`);
        const end = new Date(`${clampedEnd}T00:00:00`);
        while (cur <= end) {
          allDates.push(cur.toISOString().substring(0, 10));
          cur.setDate(cur.getDate() + 1);
        }
      });
      setLeaveDates(allDates);
    } catch (e) {
      console.error('Failed to fetch employee leaves', e);
    }
  }, [authAxios, year, month]);

  useEffect(() => {
    fetchLeaves();
  }, [fetchLeaves]);

  const fetchPrebookings = useCallback(async () => {
    try {
      const startDate = `${year}-${String(month + 1).padStart(2, '0')}-01`;
      const lastDay = new Date(year, month + 1, 0).getDate();
      const endDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
      const { data } = await authAxios.get(
        `${PRIVATE_ROUTE.GET_PREBOOKING_DATE_RANGE}?start_date=${startDate}&end_date=${endDate}`
      );
      const records = data.data || [];
      setPrebookingRecords(records);
      setPrebookingDates(records.map((p) => p.date?.substring(0, 10)).filter(Boolean));
    } catch (e) {
      console.error('Failed to fetch prebookings', e);
    }
  }, [authAxios, year, month]);

  useEffect(() => {
    fetchPrebookings();
  }, [fetchPrebookings]);

  // ============================================================
  // FETCH AVAILABLE DWR WORK
  //
  // IMPORTANT:
  // Only employee_id is sent.
  // TodoDraft records are intentionally not displayed.
  // ============================================================

  const fetchAvailableDwrWork =
    useCallback(async () => {
      if (!currentUser?._id) {
        return;
      }

      try {
        setAvailableDwrLoading(true);

        const { data } =
          await authAxios.get(
            `${PRIVATE_ROUTE.GET_DWR_AVAILABLE_WORK}?employee_id=${encodeURIComponent(
              currentUser._id
            )}`
          );

        const schedules =
          data?.data?.schedules || [];

        const employeeId =
          String(currentUser._id);

        /*
         * Today as YYYY-MM-DD.
         *
         * Use the browser's local date so the Daily Work
         * Report does not incorrectly move across UTC dates.
         */
        const today =
          new Date()
            .toLocaleDateString('en-CA');

        const availableSchedules =
          schedules.filter((schedule) => {
            /*
             * ------------------------------------------------------
             * EMPLOYEE ASSIGNMENT
             * ------------------------------------------------------
             */
            const employeeAssignment =
              schedule?.assigned_members?.find(
                (member) =>
                  String(member?.employee) ===
                  employeeId ||
                  String(
                    member?.employee_data?._id
                  ) === employeeId
              );

            // Employee is not assigned
            if (!employeeAssignment) {
              return false;
            }

            /*
             * ------------------------------------------------------
             * FUTURE DATE
             * ------------------------------------------------------
             *
             * Do not show future-dated schedules in Daily Work Report.
             *
             * Example:
             * Today       = 2026-10-01
             * planned_date= 2026-10-02
             *             → hidden
             *
             * planned_date= 2026-10-01
             *             → allowed
             *
             * planned_date= 2026-09-30
             *             → allowed
             */
            if (schedule?.planned_date) {
              const plannedDate =
                String(
                  schedule.planned_date
                ).substring(0, 10);

              if (plannedDate > today) {
                return false;
              }
            }

            /*
             * ------------------------------------------------------
             * DWR STATUS
             * ------------------------------------------------------
             */

            // No DWR submitted yet
            if (!employeeAssignment?.dwr_id) {
              return true;
            }

            // Rejected DWR can be submitted again
            if (
              employeeAssignment?.dwr_status
                ?.toLowerCase() === 'rejected'
            ) {
              return true;
            }

            // Pending / Approved / Open
            // already have a DWR, so hide them
            return false;
          });

        setAvailableDwrWork(
          availableSchedules
        );
      } catch (error) {
        console.error(
          'Failed to fetch available DWR work',
          error
        );

        setAvailableDwrWork([]);
      } finally {
        setAvailableDwrLoading(false);
      }
    }, [
      authAxios,
      currentUser?._id,
    ]);

  // ============================================================
  // OPEN AVAILABLE DWR MODAL
  // ============================================================

  const handleOpenSubmitDwr = async () => {
    setSelectedDwrWork(null);

    setAvailableDwrWork([]); // clear stale records immediately

    setAvailableDwrModalOpen(true);

    await fetchAvailableDwrWork();
  };

  // ============================================================
  // SELECT DWR WORK
  // ============================================================

  const handleSelectDwrWork = (work) => {
    if (!work) return;

    const normalizedWork = {
      ...work,

      type: 'schedule',

      schedule: {
        ...work,

        job_number:
          work.job_number ||
          (typeof work.job_id === 'object'
            ? work.job_id?.number_str
            : work.job_id) ||
          '',

        task_number:
          work.task_number ||
          (typeof work.task_id === 'object'
            ? work.task_id?.number_str
            : work.task_id) ||
          '',

        cost_item: Array.isArray(work.cost_item)
          ? work.cost_item[0]
          : work.cost_item || '',

        planned_date:
          work.planned_date ||
          work.task_date ||
          work.field_trip_date ||
          '',

        _id: work._id,
      },

      schedule_id: work._id,

      task_id: work.task_id,
      job_id: work.job_id,
    };

    setSelectedDwrWork(normalizedWork);

    setSubmitDwrModalOpen(true);
  };

  const handleDwrSubmitted = async () => {
    // close submit modal
    setSubmitDwrModalOpen(false);

    // clear selected record
    setSelectedDwrWork(null);

    // force fresh API call
    await fetchAvailableDwrWork();

    // optional: remount submit modal completely
    setDwrRefreshKey((prev) => prev + 1);
  };

  // ============================================================
  // CLOSE DWR MODAL
  // ============================================================

  const handleCloseDwrModal = () => {
    setAvailableDwrModalOpen(false);
  };

  const handleCloseSubmitDwrModal = () => {
    setSubmitDwrModalOpen(false);

    setTimeout(() => {
      setSelectedDwrWork(null);
    }, 300);
  };

  // Month names
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelectEvent = (e, event, group) => {
    setAnchorEl(e.currentTarget);
    setSelectedEvent({ event: event, group: group });
  };

  const handleClosePop = () => {
    setAnchorEl(null);
    setSelectedEvent(null);
  };

  const handleMoreClick = (dateKey) => {
    setExpandedDate((prev) => (prev === dateKey ? null : dateKey));
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const years = Array.from({ length: 21 }, (_, i) => currentYear - 10 + i);

  // Get total days in month
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  // Get first day of month (0 = Sunday)
  const firstDay = new Date(year, month, 1).getDay();

  // Create empty cells before first day
  const blanks = Array(firstDay).fill(null);

  // Create days array
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  const groupColors = ['#65C8D0', '#4BBBC4', '#3DADB5', '#52C1CA', '#7DD4DB', '#2E9DA6'];

  const handleSubmit = () => {
    setYear(selectedYear);
    setMonth(selectedMonth);
  };

  return (
    <div>
      {openCommentModal && selectedCommentSchedule && (
        <CommentsModal
          opentStatus={openCommentModal}
          setCommentModal={setCommentModal}
          selectedSchedule={selectedCommentSchedule}
          user={state.user}
          onCommentAdded={() =>
            setCommentCounts((prev) => ({
              ...prev,
              [selectedCommentSchedule._id]: (prev[selectedCommentSchedule._id] || 0) + 1,
            }))
          }
        />
      )}
      <Box id="isMobileStyle" sx={style}>
        <Box
          sx={{
            display: 'flex',
            alignItems: isMobile ? 'flex-start' : 'center',
            justifyContent: 'space-between',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? 1 : 0,
            mb: 2,
            padding: '0.5em',
          }}
        >
          {/* Left Side - Title */}
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#2a2a2a' }}>
            Job Scheduling
          </Typography>

          {/* Right Side - Month / Year / Button */}
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              alignItems: 'center',
              flexWrap: 'nowrap',
              width: isMobile ? '100%' : 'auto',
              justifyContent: isMobile ? 'flex-start' : 'flex-end',
              minWidth: 0,
            }}
          >
            {/* Month Select */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {state?.user?.role !== 'employee' && (
                <ViewListIcon
                  sx={{ fontSize: 20, color: 'text.secondary', cursor: 'pointer' }}
                  onClick={() => navigate('/scheduling/list')}
                />
              )}
              <select
                style={styles.select}
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(Number(e.target.value))}
              >
                {months.map((m, index) => (
                  <option key={m} value={index}>
                    {m}
                  </option>
                ))}
              </select>
            </Box>

            {/* Year Select */}
            <select
              style={styles.select}
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
            >
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>

            {/* Submit Button */}
            <Button variant="contained" onClick={handleSubmit}>
              Submit
            </Button>

            {/* SUBMIT DWR ICON */}
            {state?.user?.role === 'employee' && (
              <Tooltip title="Submit DWR" arrow>
                <IconButton
                  onClick={handleOpenSubmitDwr}
                  aria-label="Submit DWR"
                  size="small"
                  sx={{
                    width: 34,
                    height: 34,
                    flexShrink: 0,
                    borderRadius: 1.25,
                    backgroundColor: '#3DADB5',
                    color: '#fff',
                    boxShadow:
                      '0 2px 6px rgba(61,173,181,0.25)',
                    '&:hover': {
                      backgroundColor: '#2E9DA6',
                      boxShadow:
                        '0 3px 9px rgba(61,173,181,0.32)',
                    },
                  }}
                >
                  <AssignmentTurnedInIcon
                    sx={{
                      fontSize: 18,
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </Box>

        {/* Estimated Hours Legend */}
        <ColorLegend />

        <div style={{ overflowY: 'auto', flex: 1 }}>
          <div style={styles.calendar}>
            {/* Headers */}
            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
              <div key={day} style={styles.header}>
                {day}
              </div>
            ))}

            {/* Empty cells */}
            {blanks.map((_, index) => (
              <div
                key={`blank-${index}`}
                style={{
                  ...styles.cell,
                  ...styles.empty,
                  minHeight: isMobile ? '60px' : '130px',
                  height: isMobile ? '60px' : '130px',
                }}
              />
            ))}

            {/* Days */}
            {days.map((day) => {
              const dateKey = formatDate(year, month, day);
              const isToday = day === today.getDate() && month === today.getMonth() && year === today.getFullYear();

              let dayEvents = calanderData && calanderData[dateKey] ? calanderData[dateKey] : null;

              let groups = dayEvents ? Object.keys(dayEvents) : [];
              const isExpanded = expandedDate === dateKey;
              const isHoliday = Boolean(holidayMap[dateKey]);
              const holidayDescription = holidayMap[dateKey];

              const visibleEvents = dayEvents || null;
              const allGroupKeys = visibleEvents ? Object.keys(visibleEvents) : [];
              const visibleGroupKeys = allGroupKeys.slice(0, 2);
              const hiddenCount = allGroupKeys.length - 2;

              return (
                <div
                  key={day}
                  style={{
                    ...styles.cell,
                    backgroundColor: isHoliday ? '#FFF8F8' : isToday ? '#f0fafb' : '#fafafa',
                    borderLeft: isHoliday ? '3px solid #d32f2f' : '1px solid #ccc',
                    height: isMobile ? '60px' : '130px',
                    minHeight: isMobile ? '60px' : '130px',
                    padding: 0,
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  {/* Leave & Prebooking icons — top-left corner, side by side */}
                  <div style={{ position: 'absolute', top: 2, left: 2, display: 'flex', gap: 2, zIndex: 1 }}>
                    {leaveDates.includes(dateKey) && (
                      <Tooltip title="Employee Leave" arrow placement="top">
                        <IconButton
                          size="small"
                          onClick={() =>
                            setViewLeaveModal({
                              open: true,
                              date: dateKey,
                              records: leaveRecords.filter((l) => {
                                const from = l.date_from?.substring(0, 10);
                                if (!from) return false;
                                const to = l.date_to?.substring(0, 10);
                                if (!to) return from === dateKey;
                                return dateKey >= from && dateKey <= to;
                              }),
                            })
                          }
                          sx={{ p: '2px', color: '#F59E0B', '&:hover': { backgroundColor: '#FEF3C7' } }}
                        >
                          <EventBusyIcon sx={{ fontSize: 'clamp(11px, 1.2vw, 15px)' }} />
                        </IconButton>
                      </Tooltip>
                    )}
                    {prebookingDates.includes(dateKey) && (
                      <Tooltip title="Prebooking" arrow placement="top">
                        <IconButton
                          size="small"
                          onClick={() =>
                            setViewPrebookingModal({
                              open: true,
                              date: dateKey,
                              records: prebookingRecords.filter((p) => p.date?.substring(0, 10) === dateKey),
                            })
                          }
                          sx={{ p: '2px', color: '#7C3AED', '&:hover': { backgroundColor: '#EDE9FE' } }}
                        >
                          <BookOnlineIcon sx={{ fontSize: 'clamp(11px, 1.2vw, 15px)' }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>

                  {/* Date number + holiday text (desktop) or tooltip (mobile) */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      padding: '3px 5px 2px',
                      gap: '4px',
                      minWidth: 0,
                    }}
                  >
                    {isHoliday && !isMobile && (
                      <span
                        style={{
                          fontSize: 'clamp(7px, 0.75vw, 9px)',
                          fontWeight: 600,
                          fontStyle: 'italic',
                          color: '#d32f2f',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        {holidayDescription}
                      </span>
                    )}
                    <Tooltip
                      title={holidayDescription || ''}
                      placement="top"
                      arrow
                      open={isHoliday ? tooltipOpenDate === dateKey : false}
                      disableHoverListener
                      disableFocusListener
                      disableTouchListener
                    >
                      <span
                        role={isHoliday ? 'button' : undefined}
                        tabIndex={isHoliday ? 0 : undefined}
                        onClick={
                          isHoliday
                            ? (e) => {
                              e.stopPropagation();
                              setTooltipOpenDate((prev) => (prev === dateKey ? null : dateKey));
                            }
                            : undefined
                        }
                        onKeyDown={
                          isHoliday
                            ? (e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.stopPropagation();
                                setTooltipOpenDate((prev) => (prev === dateKey ? null : dateKey));
                              }
                            }
                            : undefined
                        }
                        style={{
                          width: 22,
                          height: 22,
                          borderRadius: '50%',
                          backgroundColor:
                            isToday && isHoliday
                              ? '#d32f2f'
                              : isToday
                                ? '#3DADB5'
                                : isHoliday
                                  ? '#ffebee'
                                  : 'transparent',
                          color: isToday ? '#fff' : isHoliday ? '#d32f2f' : '#333',
                          fontWeight: isToday || isHoliday ? 'bold' : '500',
                          fontSize: 'clamp(10px, 1.1vw, 13px)',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          lineHeight: 1,
                          flexShrink: 0,
                          border: isHoliday && !isToday ? '1px solid #ef9a9a' : 'none',
                          cursor: isMobile && isHoliday ? 'pointer' : 'default',
                        }}
                      >
                        {day}
                      </span>
                    </Tooltip>
                  </div>

                  {/* Mobile: Show Details button */}
                  {isMobile ? (
                    allGroupKeys.length > 0 && (
                      <div
                        style={{
                          flex: 1,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '2px',
                        }}
                      >
                        <button
                          type="button"
                          onClick={() => setSelectedDayPopup({ dateKey, dayEvents })}
                          style={{
                            fontSize: '8px',
                            fontWeight: '700',
                            color: '#fff',
                            background: '#3DADB5',
                            border: 'none',
                            borderRadius: '4px',
                            padding: '3px 5px',
                            cursor: 'pointer',
                            width: '100%',
                          }}
                        >
                          View
                        </button>
                      </div>
                    )
                  ) : (
                    <>
                      {/* Group event chips */}
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '3px',
                          padding: '0 3px',
                          overflowY: 'hidden',
                          flex: 1,
                          minHeight: 0,
                        }}
                      >
                        {visibleGroupKeys.map((group, index) => {
                          const color = groupColors[index % groupColors.length];
                          const groupSchedules = visibleEvents[group] || [];

                          const isCurrentEmployeeGroup = isCurrentEmployeeInGroup(
                            groupSchedules,
                            currentUser?._id
                          );

                          const members = getGroupMembers(groupSchedules);

                          return (
                            <div key={group}>
                              <button
                                type="button"
                                onClick={(e) =>
                                  handleSelectEvent(e, dayEvents[group], group)
                                }
                                style={{
                                  width: '100%',
                                  boxSizing: 'border-box',
                                  display: 'block',
                                  background: isCurrentEmployeeGroup
                                    ? '#DDF5F6'
                                    : `${color}18`,
                                  border: isCurrentEmployeeGroup
                                    ? '1px solid #168C95'
                                    : '1px solid transparent',
                                  borderLeft: `4px solid ${isCurrentEmployeeGroup ? '#168C95' : color
                                    }`,
                                  borderRadius: '4px',
                                  padding: isCurrentEmployeeGroup ? '3px 4px' : '3px 5px',
                                  cursor: 'pointer',
                                  textAlign: 'left',
                                  overflow: 'hidden',
                                  boxShadow: isCurrentEmployeeGroup
                                    ? '0 1px 4px rgba(22,140,149,0.25)'
                                    : 'none',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    minWidth: 0,
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: 'clamp(9px, 1vw, 11px)',
                                      fontWeight: isCurrentEmployeeGroup ? 600 : 600,
                                      color: isCurrentEmployeeGroup ? '#116D74' : color,
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      flexShrink: 1,
                                      minWidth: 0,
                                    }}
                                  >
                                    Group {group}
                                  </span>

                                  <span
                                    style={{
                                      background: isCurrentEmployeeGroup ? '#168C95' : color,
                                      color: '#fff',
                                      borderRadius: '8px',
                                      padding: '0 5px',
                                      fontSize: 'clamp(8px, 0.85vw, 10px)',
                                      fontWeight: 700,
                                      flexShrink: 0,
                                      lineHeight: '14px',
                                      marginLeft: 'auto',
                                    }}
                                  >
                                    {groupSchedules.length}
                                  </span>
                                </div>

                                {members.length > 0 && (
                                  <div
                                    style={{
                                      fontSize: 'clamp(8px, 0.8vw, 10px)',
                                      color: '#666',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      marginTop: '1px',
                                    }}
                                  >
                                    {members.map((member, index) => {
                                      const currentUserName = [
                                        currentUser?.first_name || '',
                                        currentUser?.last_name || '',
                                      ]
                                        .join(' ')
                                        .trim()
                                        .toLowerCase();

                                      const isMe =
                                        (member.id &&
                                          String(member.id) === String(currentUser?._id || '')) ||
                                        (
                                          currentUserName &&
                                          member.name.trim().toLowerCase() === currentUserName
                                        );

                                      return (
                                        <React.Fragment key={member.id || member.name}>
                                          {index > 0 && ', '}
                                          <span
                                            style={{
                                              color: isMe ? '#168C95' : '#666',
                                              fontWeight: isMe ? 400 : 400,
                                            }}
                                          >
                                            {member.name}
                                          </span>
                                        </React.Fragment>
                                      );
                                    })}
                                  </div>
                                )}
                              </button>
                            </div>
                          );
                        })}
                      </div>

                      {/* More / Less toggle */}
                      {hiddenCount > 0 && (
                        <button
                          type="button"
                          onClick={() => setSelectedDayPopup({ dateKey, dayEvents })}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '2px',
                            margin: '2px 3px 2px',
                            padding: '3px 6px',
                            border: `1px solid #3DADB5`,
                            borderRadius: '10px',
                            background: 'rgba(61,173,181,0.08)',
                            color: '#3DADB5',
                            fontSize: 'clamp(7px, 0.8vw, 10px)',
                            fontWeight: '700',
                            cursor: 'pointer',
                            letterSpacing: '0.2px',
                            width: 'calc(100% - 6px)',
                            lineHeight: '1.6',
                          }}
                        >
                          {`+${hiddenCount} more`}
                        </button>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </Box>

      <ViewLeaveModal
        open={viewLeaveModal.open}
        onClose={() => setViewLeaveModal({ open: false, date: '', records: [] })}
        date={viewLeaveModal.date}
        records={viewLeaveModal.records}
        isAdminOrManager={isAdminOrManager}
      />

      <ViewPrebookingModal
        open={viewPrebookingModal.open}
        onClose={() => setViewPrebookingModal({ open: false, date: '', records: [] })}
        date={viewPrebookingModal.date}
        records={viewPrebookingModal.records}
      />

      {/* ====================================================== */}
      {/* AVAILABLE DWR WORK MODAL - ENTERPRISE LAYOUT           */}
      {/* ====================================================== */}

      <Dialog
        open={availableDwrModalOpen}
        onClose={handleCloseDwrModal}
        fullWidth
        maxWidth="lg"
        keepMounted={false}
        PaperProps={{
          sx: {
            width: {
              xs: 'calc(100% - 24px)',
              sm: 'calc(100% - 32px)',
              md: '100%',
            },

            maxWidth: {
              xs: 'none',
              sm: 'none',
              md: '1200px',
            },

            margin: {
              xs: '12px',
              sm: '16px',
              md: '32px',
            },

            borderRadius: {
              xs: 2,
              sm: 2.5,
            },

            overflow: 'hidden',

            backgroundColor: '#F6F8FA',

            height: {
              xs: 'calc(100dvh - 24px)',
              sm: 'calc(100dvh - 32px)',
              md: 'auto',
            },

            maxHeight: {
              xs: 'calc(100dvh - 24px)',
              sm: 'calc(100dvh - 32px)',
              md: '86vh',
            },

            display: 'flex',
            flexDirection: 'column',

            boxShadow:
              '0 20px 60px rgba(15, 35, 45, 0.18)',
          },
        }}
      >
        {/* ==================================================== */}
        {/* MODAL HEADER                                         */}
        {/* ==================================================== */}

        <Box
          sx={{
            flexShrink: 0,

            /* TEAL ENTERPRISE HEADER */
            backgroundColor: '#3DADB5',

            borderBottom: '1px solid #2E9DA6',
          }}
        >
          <Box
            sx={{
              minHeight: {
                xs: 72,
                sm: 82,
              },

              px: {
                xs: 2,
                sm: 3,
              },

              py: {
                xs: 1.5,
                sm: 1.75,
              },

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',

              gap: 2,

              position: 'relative',
            }}
          >
            {/* ================================================= */}
            {/* LEFT - TITLE                                      */}
            {/* ================================================= */}

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',

                gap: {
                  xs: 1.25,
                  sm: 1.5,
                },

                minWidth: 0,
              }}
            >
              {/* =============================================== */}
              {/* ICON                                             */}
              {/* =============================================== */}

              <Box
                sx={{
                  width: {
                    xs: 40,
                    sm: 46,
                  },

                  height: {
                    xs: 40,
                    sm: 46,
                  },

                  flexShrink: 0,

                  borderRadius: 1.5,

                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',

                  backgroundColor: 'rgba(255,255,255,0.16)',

                  border:
                    '1px solid rgba(255,255,255,0.24)',

                  color: '#FFFFFF',
                }}
              >
                <AssignmentTurnedInIcon
                  sx={{
                    fontSize: {
                      xs: 21,
                      sm: 24,
                    },
                  }}
                />
              </Box>

              {/* =============================================== */}
              {/* TITLE CONTENT                                   */}
              {/* =============================================== */}

              <Box
                sx={{
                  minWidth: 0,
                }}
              >
                {/* EYEBROW */}

                <Typography
                  sx={{
                    color: 'rgba(255,255,255,0.82)',

                    fontSize: {
                      xs: '0.62rem',
                      sm: '0.68rem',
                    },

                    lineHeight: 1.2,

                    letterSpacing: '0.12em',

                    fontWeight: 700,

                    textTransform: 'uppercase',

                    mb: 0.35,
                  }}
                >
                  Daily Work Report
                </Typography>

                {/* TITLE */}

                <Typography
                  sx={{
                    color: '#FFFFFF',

                    fontSize: {
                      xs: '1rem',
                      sm: '1.2rem',
                    },

                    lineHeight: 1.25,

                    fontWeight: 700,

                    letterSpacing: '-0.01em',

                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Available Work
                </Typography>

                {/* DESCRIPTION */}

                <Typography
                  sx={{
                    color: 'rgba(255,255,255,0.78)',

                    fontSize: {
                      xs: '0.68rem',
                      sm: '0.74rem',
                    },

                    lineHeight: 1.3,

                    mt: 0.25,

                    display: {
                      xs: 'none',
                      sm: 'block',
                    },
                  }}
                >
                  Select a scheduled work item to prepare your daily report.
                </Typography>
              </Box>
            </Box>

            {/* ================================================= */}
            {/* RIGHT - CLOSE                                    */}
            {/* ================================================= */}

            <IconButton
              onClick={handleCloseDwrModal}
              aria-label="Close daily work report"
              sx={{
                width: 36,
                height: 36,

                flexShrink: 0,

                borderRadius: 1,

                color: '#FFFFFF',

                border:
                  '1px solid rgba(255,255,255,0.32)',

                backgroundColor:
                  'rgba(255,255,255,0.10)',

                '&:hover': {
                  backgroundColor:
                    'rgba(255,255,255,0.20)',

                  borderColor:
                    'rgba(255,255,255,0.48)',

                  color: '#FFFFFF',
                },
              }}
            >
              <CloseIcon
                sx={{
                  fontSize: 19,
                }}
              />
            </IconButton>
          </Box>

          {/* ================================================== */}
          {/* SUMMARY BAR                                        */}
          {/* ================================================== */}

          <Box
            sx={{
              px: {
                xs: 2,
                sm: 3,
              },

              py: {
                xs: 1,
                sm: 1.15,
              },

              backgroundColor: '#F7FAFB',

              borderTop:
                '1px solid rgba(255,255,255,0.18)',

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',

              gap: 1,

              flexWrap: 'wrap',
            }}
          >
            {/* LEFT */}

            <Typography
              sx={{
                color: '#62747D',

                fontSize: {
                  xs: '0.7rem',
                  sm: '0.75rem',
                },

                fontWeight: 500,
              }}
            >
              Work items available for DWR submission
            </Typography>

            {/* COUNT */}

            {!availableDwrLoading && (
              <Box
                sx={{
                  display: 'inline-flex',

                  alignItems: 'center',
                  justifyContent: 'center',

                  minWidth: 28,
                  height: 24,

                  px: 0.9,

                  borderRadius: 1.5,

                  backgroundColor:
                    availableDwrWork.length > 0
                      ? '#E7F7F8'
                      : '#EEF2F3',

                  border:
                    availableDwrWork.length > 0
                      ? '1px solid #C7E9EC'
                      : '1px solid #DCE5E8',

                  color:
                    availableDwrWork.length > 0
                      ? '#287F87'
                      : '#6C7B83',

                  fontSize: '0.72rem',

                  fontWeight: 700,
                }}
              >
                {availableDwrWork.length}
              </Box>
            )}
          </Box>
        </Box>

        {/* ==================================================== */}
        {/* CONTENT                                              */}
        {/* ==================================================== */}

        <Box
          sx={{
            flex: 1,

            minHeight: 0,

            overflowY: 'auto',
            overflowX: 'hidden',

            px: {
              xs: 1.25,
              sm: 2,
              md: 3,
            },

            py: {
              xs: 1.5,
              sm: 2,
              md: 2.5,
            },

            WebkitOverflowScrolling: 'touch',

            boxSizing: 'border-box',
          }}
        >
          {/* ================================================== */}
          {/* LOADING STATE                                      */}
          {/* ================================================== */}

          {availableDwrLoading ? (
            <Box
              sx={{
                minHeight: {
                  xs: 260,
                  sm: 320,
                },

                display: 'flex',

                alignItems: 'center',
                justifyContent: 'center',

                flexDirection: 'column',

                gap: 1.5,
              }}
            >
              <CircularProgress
                size={30}
                thickness={4}
                sx={{
                  color: '#3DADB5',
                }}
              />

              <Typography
                sx={{
                  color: '#647780',

                  fontSize: {
                    xs: '0.78rem',
                    sm: '0.84rem',
                  },

                  fontWeight: 500,
                }}
              >
                Loading available work...
              </Typography>
            </Box>
          ) : availableDwrWork.length === 0 ? (
            /* ================================================== */
            /* EMPTY STATE                                       */
            /* ================================================== */

            <Box
              sx={{
                minHeight: {
                  xs: 260,
                  sm: 320,
                },

                display: 'flex',

                alignItems: 'center',
                justifyContent: 'center',

                px: 2,
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  maxWidth: 460,

                  textAlign: 'center',

                  backgroundColor: '#FFFFFF',

                  border:
                    '1px solid #DCE5E8',

                  borderRadius: 2,

                  px: {
                    xs: 2.5,
                    sm: 4,
                  },

                  py: {
                    xs: 3,
                    sm: 4,
                  },

                  boxShadow:
                    '0 2px 8px rgba(25, 50, 60, 0.04)',
                }}
              >
                <Box
                  sx={{
                    width: 52,
                    height: 52,

                    mx: 'auto',
                    mb: 1.5,

                    display: 'flex',

                    alignItems: 'center',
                    justifyContent: 'center',

                    borderRadius: '50%',

                    backgroundColor: '#F0F4F5',

                    color: '#819199',
                  }}
                >
                  <AssignmentTurnedInIcon
                    sx={{
                      fontSize: 25,
                    }}
                  />
                </Box>

                <Typography
                  sx={{
                    color: '#253740',

                    fontSize: {
                      xs: '0.92rem',
                      sm: '1rem',
                    },

                    fontWeight: 700,

                    mb: 0.75,
                  }}
                >
                  No Available Work
                </Typography>

                <Typography
                  sx={{
                    color: '#71818A',

                    fontSize: {
                      xs: '0.75rem',
                      sm: '0.8rem',
                    },

                    lineHeight: 1.55,
                  }}
                >
                  There are currently no work items available
                  for DWR submission.
                </Typography>
              </Box>
            </Box>
          ) : (
            <>
              {/* ================================================= */}
              {/* DESKTOP TABLE                                    */}
              {/* ================================================= */}

              {!isMobile && (
                <Box
                  sx={{
                    width: '100%',

                    backgroundColor: '#FFFFFF',

                    border:
                      '1px solid #DCE5E8',

                    borderRadius: 2,

                    overflow: 'hidden',

                    boxShadow:
                      '0 2px 10px rgba(25, 50, 60, 0.045)',
                  }}
                >
                  <Table
                    size="small"
                    sx={{
                      width: '100%',

                      tableLayout: 'fixed',

                      '& thead th': {
                        backgroundColor: '#F3F6F7',

                        color: '#5C7079',

                        fontSize: '0.7rem',

                        fontWeight: 700,

                        letterSpacing: '0.04em',

                        textTransform: 'uppercase',

                        borderBottom:
                          '1px solid #DCE5E8',

                        py: 1.35,
                        px: 1.75,

                        whiteSpace: 'nowrap',
                      },

                      '& tbody td': {
                        color: '#263840',

                        fontSize: '0.78rem',

                        borderBottom:
                          '1px solid #EDF1F2',

                        py: 1.5,
                        px: 1.75,

                        verticalAlign: 'middle',
                      },

                      '& tbody tr:last-child td': {
                        borderBottom: 0,
                      },

                      '& tbody tr': {
                        transition:
                          'background-color 120ms ease',
                      },

                      '& tbody tr:hover': {
                        backgroundColor: '#F8FCFC',
                      },
                    }}
                  >
                    {/* TABLE HEADER */}

                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            width: '14%',
                          }}
                        >
                          Field Date
                        </TableCell>

                        <TableCell
                          sx={{
                            width: '10%',
                          }}
                        >
                          Job
                        </TableCell>

                        <TableCell
                          sx={{
                            width: '10%',
                          }}
                        >
                          Task
                        </TableCell>

                        <TableCell
                          sx={{
                            width: '27%',
                          }}
                        >
                          Cost Item
                        </TableCell>

                        <TableCell
                          sx={{
                            width: '23%',
                          }}
                        >
                          Assigned To
                        </TableCell>

                        <TableCell
                          align="right"
                          sx={{
                            width: '16%',
                          }}
                        >
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    {/* TABLE BODY */}

                    <TableBody>
                      {availableDwrWork.map(
                        (work, index) => {
                          const jobNumber =
                            work.job_number ||
                            (typeof work.job_id === 'object'
                              ? work.job_id?.number_str
                              : work.job_id) ||
                            '—';

                          const taskNumber =
                            work.task_number ||
                            (typeof work.task_id === 'object'
                              ? work.task_id?.number_str
                              : work.task_id) ||
                            '—';

                          const plannedDate =
                            work.planned_date ||
                            work.task_date ||
                            work.schedule_date ||
                            work.date ||
                            '';

                          const formattedDate =
                            plannedDate
                              ? dayjs(String(plannedDate).substring(0, 10)).format('MM/DD/YYYY')
                              : '—';

                          const costItem =
                            Array.isArray(work.cost_item)
                              ? work.cost_item.join(', ')
                              : work.cost_item || '—';

                          const assignedMembers =
                            Array.isArray(
                              work.assigned_members
                            )
                              ? work.assigned_members
                                .map((member) => {
                                  const employee =
                                    member?.employee_data ||
                                    member;

                                  return `${employee?.first_name || ''} ${employee?.last_name || ''
                                    }`.trim();
                                })
                                .filter(Boolean)
                                .join(', ')
                              : '—';

                          return (
                            <TableRow
                              key={
                                work._id ||
                                `dwr-${index}`
                              }
                            >
                              {/* FIELD DATE */}

                              <TableCell>
                                <Typography
                                  sx={{
                                    fontSize: '0.78rem',

                                    fontWeight: 600,

                                    color: '#263840',

                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formattedDate}
                                </Typography>
                              </TableCell>

                              {/* JOB */}

                              <TableCell>
                                <Box
                                  sx={{
                                    display:
                                      'inline-flex',

                                    alignItems:
                                      'center',

                                    minHeight: 26,

                                    px: 1,

                                    borderRadius: 1,

                                    backgroundColor:
                                      '#EAF7F8',

                                    border:
                                      '1px solid #CDECEF',

                                    color: '#2D7F86',

                                    fontSize: '0.72rem',

                                    fontWeight: 700,

                                    whiteSpace:
                                      'nowrap',
                                  }}
                                >
                                  {jobNumber}
                                </Box>
                              </TableCell>

                              {/* TASK */}

                              <TableCell>
                                <Typography
                                  sx={{
                                    fontSize: '0.78rem',

                                    fontWeight: 600,

                                    color: '#344B55',

                                    whiteSpace:
                                      'nowrap',
                                  }}
                                >
                                  {taskNumber}
                                </Typography>
                              </TableCell>

                              {/* COST ITEM */}

                              <TableCell>
                                <Typography
                                  sx={{
                                    fontSize: '0.78rem',

                                    fontWeight: 600,

                                    color: '#263840',

                                    lineHeight: 1.4,

                                    overflowWrap:
                                      'anywhere',
                                  }}
                                >
                                  {costItem}
                                </Typography>
                              </TableCell>

                              {/* ASSIGNED MEMBERS */}

                              <TableCell>
                                <Typography
                                  sx={{
                                    fontSize: '0.76rem',

                                    fontWeight: 500,

                                    color: '#596C75',

                                    lineHeight: 1.4,

                                    overflowWrap:
                                      'anywhere',
                                  }}
                                >
                                  {assignedMembers}
                                </Typography>
                              </TableCell>

                              {/* ACTION */}

                              <TableCell align="right">
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    handleSelectDwrWork(
                                      work
                                    );
                                  }}
                                  sx={{
                                    minWidth: 116,

                                    height: 34,

                                    px: 1.75,

                                    borderRadius: 1,

                                    backgroundColor:
                                      '#3DADB5',

                                    color: '#FFFFFF',

                                    textTransform:
                                      'none',

                                    fontSize:
                                      '0.74rem',

                                    fontWeight: 700,

                                    boxShadow:
                                      '0 2px 6px rgba(61,173,181,0.18)',

                                    '&:hover': {
                                      backgroundColor:
                                        '#2E9DA6',

                                      boxShadow:
                                        '0 4px 10px rgba(61,173,181,0.24)',
                                    },
                                  }}
                                >
                                  Submit DWR
                                </Button>
                              </TableCell>
                            </TableRow>
                          );
                        }
                      )}
                    </TableBody>
                  </Table>
                </Box>
              )}

              {/* ================================================= */}
              {/* MOBILE CARDS                                     */}
              {/* ================================================= */}

              {isMobile && (
                <Box
                  sx={{
                    display: 'flex',

                    flexDirection: 'column',

                    gap: 1.25,

                    width: '100%',
                  }}
                >
                  {availableDwrWork.map(
                    (work, index) => {
                      const jobNumber =
                        work.job_number ||
                        (typeof work.job_id === 'object'
                          ? work.job_id?.number_str
                          : work.job_id) ||
                        '—';

                      const taskNumber =
                        work.task_number ||
                        (typeof work.task_id === 'object'
                          ? work.task_id?.number_str
                          : work.task_id) ||
                        '—';

                      const costItem =
                        Array.isArray(work.cost_item)
                          ? work.cost_item.join(', ')
                          : work.cost_item || '—';

                      const plannedDate =
                        work.planned_date ||
                        work.task_date ||
                        work.schedule_date ||
                        work.date ||
                        '';

                      const formattedDate =
                        plannedDate
                          ? String(plannedDate).substring(
                            0,
                            10
                          )
                          : '—';

                      const assignedMembers =
                        Array.isArray(
                          work.assigned_members
                        )
                          ? work.assigned_members
                            .map((member) => {
                              const employee =
                                member?.employee_data ||
                                member;

                              return `${employee?.first_name || ''} ${employee?.last_name || ''
                                }`.trim();
                            })
                            .filter(Boolean)
                            .join(', ')
                          : '—';

                      return (
                        <Box
                          key={
                            work._id ||
                            `mobile-dwr-${index}`
                          }
                          sx={{
                            width: '100%',

                            minWidth: 0,

                            boxSizing: 'border-box',

                            backgroundColor:
                              '#FFFFFF',

                            border:
                              '1px solid #DCE5E8',

                            borderRadius: 2,

                            overflow: 'hidden',

                            boxShadow:
                              '0 2px 8px rgba(25, 50, 60, 0.045)',
                          }}
                        >
                          {/* CARD TOP ACCENT */}

                          <Box
                            sx={{
                              height: 3,

                              backgroundColor:
                                '#3DADB5',
                            }}
                          />

                          {/* CARD CONTENT */}

                          <Box
                            sx={{
                              px: 1.75,

                              pt: 1.5,

                              pb: 1.5,

                              minWidth: 0,
                            }}
                          >
                            {/* JOB / TASK / DATE */}

                            <Box
                              sx={{
                                display: 'flex',

                                alignItems:
                                  'flex-start',

                                justifyContent:
                                  'space-between',

                                gap: 1,

                                minWidth: 0,

                                mb: 1.25,
                              }}
                            >
                              {/* JOB + TASK */}

                              <Box
                                sx={{
                                  display:
                                    'flex',

                                  alignItems:
                                    'center',

                                  gap: 0.65,

                                  minWidth: 0,

                                  flexWrap:
                                    'wrap',
                                }}
                              >
                                <Box
                                  sx={{
                                    display:
                                      'inline-flex',

                                    alignItems:
                                      'center',

                                    minHeight: 25,

                                    px: 0.9,

                                    borderRadius: 1,

                                    backgroundColor:
                                      '#EAF7F8',

                                    border:
                                      '1px solid #CDECEF',

                                    color: '#2D7F86',

                                    fontSize:
                                      '0.68rem',

                                    fontWeight: 700,

                                    whiteSpace:
                                      'nowrap',
                                  }}
                                >
                                  Job #{jobNumber}
                                </Box>

                                <Typography
                                  sx={{
                                    color:
                                      '#566A73',

                                    fontSize:
                                      '0.68rem',

                                    fontWeight:
                                      700,

                                    whiteSpace:
                                      'nowrap',
                                  }}
                                >
                                  Task #{taskNumber}
                                </Typography>
                              </Box>

                              {/* DATE */}

                              <Typography
                                sx={{
                                  color:
                                    '#71818A',

                                  fontSize:
                                    '0.67rem',

                                  fontWeight:
                                    600,

                                  whiteSpace:
                                    'nowrap',

                                  flexShrink: 0,
                                }}
                              >
                                {formattedDate}
                              </Typography>
                            </Box>

                            {/* COST ITEM */}

                            <Typography
                              sx={{
                                color:
                                  '#1F313A',

                                fontSize:
                                  '0.9rem',

                                lineHeight:
                                  1.35,

                                fontWeight:
                                  700,

                                overflowWrap:
                                  'anywhere',

                                mb: 1.4,
                              }}
                            >
                              {costItem}
                            </Typography>

                            {/* DETAILS GRID */}

                            <Box
                              sx={{
                                display:
                                  'grid',

                                gridTemplateColumns:
                                  'minmax(0, 1fr)',

                                gap: 1,

                                p: 1.15,

                                backgroundColor:
                                  '#F7FAFB',

                                border:
                                  '1px solid #E7EDEF',

                                borderRadius:
                                  1.5,

                                minWidth: 0,
                              }}
                            >
                              <Box
                                sx={{
                                  minWidth: 0,
                                }}
                              >
                                <Typography
                                  sx={{
                                    color:
                                      '#82919A',

                                    fontSize:
                                      '0.62rem',

                                    lineHeight:
                                      1.2,

                                    fontWeight:
                                      700,

                                    letterSpacing:
                                      '0.06em',

                                    textTransform:
                                      'uppercase',

                                    mb: 0.35,
                                  }}
                                >
                                  Assigned To
                                </Typography>

                                <Typography
                                  sx={{
                                    color:
                                      '#344851',

                                    fontSize:
                                      '0.76rem',

                                    lineHeight:
                                      1.4,

                                    fontWeight:
                                      500,

                                    overflowWrap:
                                      'anywhere',

                                    wordBreak:
                                      'break-word',
                                  }}
                                >
                                  {assignedMembers}
                                </Typography>
                              </Box>
                            </Box>

                            {/* ACTION */}

                            <Button
                              fullWidth
                              variant="contained"
                              onClick={() =>
                                handleSelectDwrWork(
                                  work
                                )
                              }
                              sx={{
                                mt: 1.25,

                                minHeight: 38,

                                borderRadius: 1.25,

                                backgroundColor:
                                  '#3DADB5',

                                color: '#FFFFFF',

                                textTransform:
                                  'none',

                                fontSize:
                                  '0.78rem',

                                fontWeight: 700,

                                boxShadow:
                                  '0 2px 7px rgba(61,173,181,0.18)',

                                '&:hover': {
                                  backgroundColor:
                                    '#2E9DA6',
                                },
                              }}
                            >
                              Submit Daily Work Report
                            </Button>
                          </Box>
                        </Box>
                      );
                    }
                  )}
                </Box>
              )}
            </>
          )}
        </Box>

        {/* ==================================================== */}
        {/* MODAL FOOTER                                         */}
        {/* ==================================================== */}

        <Box
          sx={{
            flexShrink: 0,

            minHeight: {
              xs: 48,
              sm: 52,
            },

            px: {
              xs: 2,
              sm: 3,
            },

            py: {
              xs: 0.9,
              sm: 1,
            },

            display: 'flex',

            alignItems: 'center',

            justifyContent: 'space-between',

            gap: 1,

            backgroundColor: '#FFFFFF',

            borderTop:
              '1px solid #DCE5E8',
          }}
        >
          <Typography
            sx={{
              color: '#819099',

              fontSize: {
                xs: '0.65rem',
                sm: '0.7rem',
              },

              lineHeight: 1.35,
            }}
          >
            {/* Select a work item to continue. */}
          </Typography>

          <Button
            size="small"
            onClick={handleCloseDwrModal}
            sx={{
              minWidth: 70,

              minHeight: 30,

              px: 1.25,

              borderRadius: 1,

              color: '#3DADB5',

              border:
                '1px solid #C7E9EC',

              backgroundColor:
                '#F3FBFB',

              textTransform: 'none',

              fontSize: '0.72rem',

              fontWeight: 600,

              '&:hover': {
                backgroundColor: '#E7F7F8',

                borderColor:
                  '#3DADB5',

                color: '#2E8F96',
              },
            }}
          >
            Close
          </Button>
        </Box>
      </Dialog>


      {/* ====================================================== */}
      {/* EXISTING SUBMIT DWR MODAL */}
      {/* ====================================================== */}

      <SubmitDwrModal
        key={dwrRefreshKey}
        open={submitDwrModalOpen}
        onClose={handleCloseSubmitDwrModal}
        selectedWork={selectedDwrWork}
        onDwrSubmitted={handleDwrSubmitted}
      />

      {/* Mobile Day Detail Popup */}
      <Dialog
        open={Boolean(selectedDayPopup)}
        onClose={() => setSelectedDayPopup(null)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden',
            maxHeight: '80vh',
            display: 'flex',
            flexDirection: 'column',
            width: {
              xs: 'calc(100% - 24px)',
              sm: '100%',
            },
            m: {
              xs: 1.5,
              sm: 2,
            },
          },
        }}
      >
        {selectedDayPopup &&
          (() => {
            const allKeys = Object.keys(selectedDayPopup.dayEvents || {});

            return (
              <>
                {/* Header */}
                <Box
                  sx={{
                    background: '#3DADB5',
                    color: '#fff',
                    px: 2,
                    py: 1.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexShrink: 0,
                  }}
                >
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      sx={{
                        opacity: 0.85,
                        fontSize: '0.7rem',
                        letterSpacing: 1,
                        fontWeight: 600,
                      }}
                    >
                      DAY SCHEDULE
                    </Typography>

                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        lineHeight: 1.3,
                        overflowWrap: 'anywhere',
                      }}
                    >
                      {selectedDayPopup.dateKey}
                    </Typography>

                    <Typography sx={{ opacity: 0.9, fontSize: '0.78rem' }}>
                      {allKeys.length} group{allKeys.length !== 1 ? 's' : ''}
                    </Typography>
                  </Box>

                  <IconButton
                    size="small"
                    onClick={() => setSelectedDayPopup(null)}
                    aria-label="Close day schedule"
                    sx={{ color: '#fff', flexShrink: 0 }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>

                {/* Group list */}
                <Box
                  sx={{
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    flex: 1,
                    p: 1.5,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    WebkitOverflowScrolling: 'touch',
                  }}
                >
                  {allKeys.map((group, index) => {
                    const color = groupColors[index % groupColors.length];
                    const groupSchedules =
                      selectedDayPopup.dayEvents[group] || [];

                    const isCurrentEmployeeGroup = isCurrentEmployeeInGroup(
                      groupSchedules,
                      currentUser?._id
                    );

                    const members = getGroupMembers(groupSchedules);

                    return (
                      <button
                        key={group}
                        type="button"
                        onClick={(e) => {
                          handleSelectEvent(e, groupSchedules, group);
                        }}
                        style={{
                          width: '100%',
                          boxSizing: 'border-box',
                          display: 'block',
                          background: isCurrentEmployeeGroup
                            ? '#DDF5F6'
                            : `${color}18`,
                          border: isCurrentEmployeeGroup
                            ? '2px solid #168C95'
                            : '1px solid transparent',
                          borderLeft: `5px solid ${isCurrentEmployeeGroup ? '#168C95' : color
                            }`,
                          borderRadius: '6px',
                          padding: '10px 12px',
                          cursor: 'pointer',
                          textAlign: 'left',
                          overflow: 'hidden',
                          boxShadow: isCurrentEmployeeGroup
                            ? '0 2px 6px rgba(22,140,149,0.18)'
                            : 'none',
                        }}
                      >
                        {/* Group name and task count */}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 6,
                            minWidth: 0,
                          }}
                        >
                          <span
                            style={{
                              fontSize: '14px',
                              fontWeight: 800,
                              color: isCurrentEmployeeGroup ? '#116D74' : color,
                            }}
                          >
                            Group {group}
                          </span>

                          <span
                            style={{
                              background: isCurrentEmployeeGroup
                                ? '#168C95'
                                : color,
                              color: '#fff',
                              borderRadius: '10px',
                              padding: '2px 8px',
                              fontSize: '12px',
                              fontWeight: 700,
                              marginLeft: 'auto',
                              flexShrink: 0,
                            }}
                          >
                            {groupSchedules.length}
                          </span>
                        </div>

                        {/* Assigned members */}
                        {members && (
                          <div
                            style={{
                              fontSize: '12px',
                              color: '#555',
                              marginTop: '5px',
                              lineHeight: 1.5,
                              overflowWrap: 'anywhere',
                            }}
                          >
                            {Array.isArray(members)
                              ? members.map((member) =>
                                typeof member === 'string' ? member : member.name
                              ).filter(Boolean).join(', ')
                              : members}
                          </div>
                        )}
                      </button>
                    );
                  })}
                </Box>
              </>
            );
          })()}
      </Dialog>
      <Dialog
        data-id="detail_modal"
        open={Boolean(selectedEvent)}
        onClose={handleClosePop}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden',
            maxHeight: '80vh',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        {(() => {
          const groupColor = '#65C8D0';
          const groupMembers = [
            ...new Map(
              (selectedEvent?.event ?? [])
                .flatMap((schedule) => schedule.assigned_members ?? [])
                .map((member) => {
                  const employee =
                    member?.employee_data ||
                    member?.employee ||
                    member?.employee_id ||
                    member;

                  const employeeId =
                    typeof employee === 'object'
                      ? String(employee?._id || employee?.id || '')
                      : String(employee || '');

                  const firstName =
                    typeof employee === 'object'
                      ? employee?.first_name || ''
                      : '';

                  const lastName =
                    typeof employee === 'object'
                      ? employee?.last_name || ''
                      : '';

                  const name = `${firstName} ${lastName}`.trim();

                  return [
                    employeeId || name,
                    { id: employeeId, name },
                  ];
                })
                .filter(([key, member]) => key && member.name)
            ).values(),
          ];
          return (
            <>
              {/* Colored header */}
              <Box
                sx={{
                  background: groupColor,
                  color: '#fff',
                  px: 2.5,
                  py: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexShrink: 0,
                }}
              >
                <Box>
                  <Typography sx={{ opacity: 0.85, fontSize: '0.7rem', letterSpacing: 1, fontWeight: 600 }}>
                    SCHEDULE DETAILS
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                    Group {selectedEvent?.group}
                  </Typography>
                  <Typography sx={{ opacity: 0.85, fontSize: '0.78rem' }}>
                    {selectedEvent?.event?.length} task{selectedEvent?.event?.length !== 1 ? 's' : ''}
                  </Typography>
                  {groupMembers.length > 0 && (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                      {groupMembers.map((member) => {
                        const currentUserId = String(
                          state?.user?._id || ''
                        );

                        const currentUserName =
                          `${state?.user?.first_name || ''} ${state?.user?.last_name || ''}`
                            .trim()
                            .toLowerCase();

                        const isCurrentEmployee =
                          (currentUserId && member.id
                            ? member.id === currentUserId
                            : false) ||
                          (
                            member.name.trim().toLowerCase() === currentUserName &&
                            Boolean(currentUserName)
                          );

                        return (
                          <Box
                            key={member.id || member.name}
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 0.75,
                              backgroundColor: isCurrentEmployee
                                ? '#FFFFFF'
                                : 'rgba(255,255,255,0.18)',
                              border: isCurrentEmployee
                                ? '2px solid #FFFFFF'
                                : '1px solid rgba(255,255,255,0.35)',
                              borderRadius: '20px',
                              px: 1.25,
                              py: '5px',
                              boxShadow: isCurrentEmployee
                                ? '0 0 0 2px rgba(0,0,0,0.12)'
                                : 'none',
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: '0.7rem',
                                fontWeight: isCurrentEmployee ? 800 : 600,
                                color: isCurrentEmployee ? '#237F87' : '#FFFFFF',
                                lineHeight: 1,
                              }}
                            >
                              {member.name}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Box>
                <IconButton size="small" onClick={handleClosePop} sx={{ color: '#fff' }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>

              {/* Scrollable task list */}
              <Box sx={{ overflowY: 'auto', flex: 1 }}>
                {selectedEvent &&
                  [...selectedEvent.event]
                    .sort((a, b) => (a.sequence_number ?? 0) - (b.sequence_number ?? 0))
                    .map((schedule, index) => (
                      <Accordion
                        key={index}
                        disableGutters
                        elevation={0}
                        sx={{ borderBottom: '1px solid #eee', '&:before': { display: 'none' } }}
                        onChange={(_, expanded) => { if (expanded) fetchCommentCount(schedule._id); }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon sx={{ color: groupColor }} />}
                          sx={{
                            px: 2,
                            py: 0.75,
                            backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#fff',
                            '&:hover': { backgroundColor: '#EAF8F9' },
                            minHeight: 'unset',
                            '& .MuiAccordionSummary-content': { margin: '6px 0' },
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                            <Box
                              sx={{
                                background: getScheduleColor(schedule.estimated_hours, schedule.cost_item),
                                color: '#fff',
                                borderRadius: '4px',
                                px: 0.75,
                                py: 0.25,
                                fontSize: '0.7rem',
                                fontWeight: 700,
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                              }}
                            >
                              {schedule.job_id.number_str}
                            </Box>
                            <Typography
                              sx={{
                                fontSize: '0.78rem',
                                fontWeight: 600,
                                color: '#3DADB5',
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                              }}
                            >
                              {schedule.job_id.locations?.[0]?.city || ''}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: '0.82rem',
                                fontWeight: 600,
                                color: '#333',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {schedule.project_managers.map((m) => `${m.first_name} ${m.last_name}`).join(', ')}
                            </Typography>
                          </Box>
                        </AccordionSummary>

                        <AccordionDetails sx={{ px: 2, py: 1.5, backgroundColor: '#fff' }}>
                          <Table size="small">
                            <TableBody>
                              {[
                                ['Task Number', schedule.task.number_str],
                                ['Job Number', schedule.job_id.number_str],
                                ['Client', schedule.client_id.company_name],
                                [
                                  'Location',
                                  [
                                    schedule.job_id.locations?.[0]?.munciple_address,
                                    schedule.job_id.locations?.[0]?.city,
                                    schedule.job_id.locations?.[0]?.state,
                                    schedule.job_id.locations?.[0]?.postal_code,
                                  ]
                                    .filter(Boolean)
                                    .join(', '),
                                ],
                                ['Task Scope', schedule.task.task_scope_id],
                                ['Cost Item', schedule.cost_item[0]],
                              ].map(([label, value]) => (
                                <TableRow
                                  key={label}
                                  sx={{
                                    '&:last-child td': { borderBottom: 0 },
                                    '&:hover': { backgroundColor: '#EAF8F9' },
                                  }}
                                >
                                  <TableCell
                                    sx={{
                                      color: '#555',
                                      fontWeight: 600,
                                      fontSize: '0.78rem',
                                      backgroundColor: '#E0F6F8',
                                      borderRight: '1px solid #e0e0e0',
                                      width: '38%',
                                      py: 0.75,
                                    }}
                                  >
                                    {label}
                                  </TableCell>
                                  <TableCell sx={{ fontSize: '0.78rem', color: '#222', py: 0.75 }}>
                                    {value || '—'}
                                  </TableCell>
                                </TableRow>
                              ))}
                              <TableRow sx={{ '&:hover': { backgroundColor: '#EAF8F9' } }}>
                                <TableCell
                                  sx={{
                                    color: '#555',
                                    fontWeight: 600,
                                    fontSize: '0.78rem',
                                    backgroundColor: '#E0F6F8',
                                    borderRight: '1px solid #e0e0e0',
                                    width: '38%',
                                    py: 0.75,
                                  }}
                                >
                                  Document Link
                                </TableCell>
                                <TableCell sx={{ fontSize: '0.78rem', py: 0.75 }}>
                                  {schedule.document_link ? (
                                    <a
                                      href={
                                        /^https?:\/\//i.test(schedule.document_link)
                                          ? schedule.document_link
                                          : `https://${schedule.document_link}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: '#3DADB5', fontWeight: 600, wordBreak: 'break-all' }}
                                    >
                                      {schedule.document_link}
                                    </a>
                                  ) : (
                                    '—'
                                  )}
                                </TableCell>
                              </TableRow>
                              <TableRow sx={{ '&:hover': { backgroundColor: '#EAF8F9' } }}>
                                <TableCell
                                  sx={{
                                    color: '#555',
                                    fontWeight: 600,
                                    fontSize: '0.78rem',
                                    backgroundColor: '#E0F6F8',
                                    borderRight: '1px solid #e0e0e0',
                                    width: '38%',
                                    py: 0.75,
                                    borderBottom: 0,
                                  }}
                                >
                                  Description
                                </TableCell>
                                <TableCell sx={{ fontSize: '0.78rem', color: '#222', py: 0.75, borderBottom: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                  {schedule.description || '—'}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <Button
                              size="small"
                              variant={commentCounts[schedule._id] > 0 ? 'contained' : 'text'}
                              startIcon={<CommentIcon sx={{ fontSize: '14px !important' }} />}
                              onClick={() => {
                                setSelectedCommentSchedule(schedule);
                                setCommentModal(true);
                              }}
                              sx={
                                commentCounts[schedule._id] > 0
                                  ? {
                                    backgroundColor: '#65C8D0',
                                    color: '#fff',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    fontSize: '0.75rem',
                                    '&:hover': { backgroundColor: '#3DADB5' },
                                  }
                                  : {
                                    color: '#3DADB5',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    '&:hover': { backgroundColor: '#E0F6F8' },
                                  }
                              }
                            >
                              {commentCounts[schedule._id] > 0 ? `Comments (${commentCounts[schedule._id]})` : 'Comments'}
                            </Button>
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    ))}
              </Box>
            </>
          );
        })()}
      </Dialog>
    </div>
  );
}